import { CancellableResult } from '../../common/result';
import { CustomError } from '../../common/errors';

export type Document = {
  id: string;
  documentType: string;
};

export type DocumentCaptureResult = CancellableResult<CustomError, Document>;

export enum DocumentType {
  // 'licence' spelled with a 'c' to match Onfido's config
  DRIVING_LICENCE = 'driving_licence',
  NATIONAL_IDENTITY_CARD = 'national_identity_card',
  RESIDENCE_PERMIT = 'residence_permit',
  PASSPORT = 'passport',
}
export const DEFAULT_SUPPORTED_DOCUMENT_TYPES: DocumentType[] = [
  DocumentType.DRIVING_LICENCE,
  DocumentType.NATIONAL_IDENTITY_CARD,
  DocumentType.RESIDENCE_PERMIT,
  DocumentType.PASSPORT,
];
export interface DocumentCapture {
  setDarkMode?(darkModeEnabled: boolean): void;
  capture(token: string, supportedDocumentTypes?: DocumentType[]): Promise<DocumentCaptureResult>;
  cleanup(): Promise<void>;
}
